import { render, staticRenderFns } from "./event-detail.vue?vue&type=template&id=fa92c838&scoped=true&"
import script from "./event-detail.vue?vue&type=script&lang=js&"
export * from "./event-detail.vue?vue&type=script&lang=js&"
import style0 from "./event-detail.vue?vue&type=style&index=0&id=fa92c838&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.7_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa92c838",
  null
  
)

export default component.exports